import { createAsyncThunk } from "@reduxjs/toolkit";

import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { heroSectionApi } from "service/heroSectionApi";

export const getHeroSection = createAsyncThunk(
  "getHeroSection",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await heroSectionApi.getHeroSection();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateHeroSection = createAsyncThunk(
  "updateHeroSection",
  async ({ mediaFile }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await heroSectionApi.updateHeroSection(mediaFile);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getHeroSection());
      return data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
